<!--
   Created by qing on 2021/1/8
   Des:
-->
<template>

  <ConfigContainer
    :value="current"
    :type="type">
    <div class="contact-me-config-container">
      <template v-if="!$store.getters.isLark">
        <img
          class="qr-code-image"
          :src="$store.getters.configMap && $store.getters.configMap.customerServiceUrl">
        <div class="tip">
          扫一扫联系您的专属客服
        </div>
      </template>
      <template v-else>
        <img
          class="lark-image"
          :src="`${$BASE_PATH}/fetch/image?id=395254112314195969.png`">
        <a
          class="lark-service"
          target="_blank"
          href="https://applink.feishu.cn/client/helpdesk/open?id=6892582748412182532&extra=%7B%22channel%22%3A1%2C%22created_at%22%3A1606724670%7D">
          联系飞书客服
        </a>
      </template>
    </div>
  </ConfigContainer>
</template>

<script>
  import ConfigContainer from './common/ConfigContainer'
  export default {
    props: {
      value: Object,
      type: Number,
      isPhone: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ConfigContainer
    },
    data() {
      return {

        current: this.value,
      }
    },
    created() {
    },
    methods: {}
  }
</script>

<style lang="less">

  .contact-me-config-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .qr-code-image {
      width: 200px;
      height: 200px;
      margin-bottom: 30px;
    }

    .tip {
      color: #5d616f;
    }

    .lark-image {
      width: 200px;
    }

    .lark-service {
      cursor: pointer;
      outline: 0;
      text-decoration: none;
      border: 1px solid #E56833;
      border-radius: 2px;
      text-align: center;
      margin-top: 20px;
      width: 200px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #E56833;
    }
  }
</style>
